<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav title="报告详情" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="pdf" ref="content">
      <pdf :src="src" ref="myPdfComponent"></pdf>
    </div>
    <div class="btn">
      <!-- <van-button size="large" type="info" @click="downloadIamge()"
        >下载报告</van-button
      > -->
    </div>
  </div>
</template>

<script>
import Nav from "../../../components/nav.vue";
import pdf from "vue-pdf";
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
import html2canvas from "html2canvas";
export default {
  components: {
    pdf,
    Nav,
  },
  data() {
    return {
      reportBase64: "",
      src: "",
      numPages: 0,
      page: 1,
      currentPage: 0,
      reqData: {},
      name: "",
      itemName: "",
      imgUrl: "",
    };
  },
  created() {
    this.reqData = this.$route.query;
    this.name = this.$route.query.name;
    this.itemName = this.$route.query.itemName;
  },
  mounted() {
    // console.log(this.reqData);
    this.getReport();
  },
  methods: {
    downloadIamge() {
      this.$nextTick(() => {
        html2canvas(this.$refs.content).then((resolve) => {
          
          this.imgUrl = resolve.toDataURL("data:image/jpeg;base64"); //此时就得到了dom元素转成了base64的图片
          console.log(this.imgUrl);
          let a = document.createElement("a"); // 生成一个a元素
          let event = new MouseEvent("click"); // 创建一个单击事件
          a.download = this.name + "报告单"; // 设置图片名称
          a.href = this.imgUrl; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        });
      });
    },

    async getReport() {
      // console.log(this.method_depy_type)
      try {
        let reqData = this.reqData;
        this.$showLoad();
        let url = "/report/api/querylisreportbysample";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            this.$hideLoad();
            let base64 = data.data.data.data.report.substr(
              1,
              data.data.data.data.report.length - 2
            );
            // console.log(base64);
            this.reportBase64 = base64;
            let datas = "data:application/pdf;base64," + base64; //  data:image/jpeg;base64,

            this.src = pdf.createLoadingTask({ url: datas, CMapReaderFactory });
            // this.src.promise.then((pdf) => {
            //   this.numPages = hospitalChekedDetail.numPages;
            // });
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    test() {
      let URL = this.dataURLtoBlob(this.reportBase64);
      let name = this.name + this.itemName + "报告单.pdf";
      var reader = new FileReader();
      reader.readAsDataURL(URL);
      reader.onload = function (e) {
        if (window.navigator.msSaveOrOpenBlob) {
          var bstr = atob(e.target.result.split(",")[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr]);

          // console.log(name);
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          // 转换完成，创建一个a标签用于下载
          const a = document.createElement("a");
          a.download = name; // 这里写你的文件名
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  .nav {
    height: 8vh;
  }
  .pdf {
    height: 80vh;
    width: 95%;
    margin: 0px auto;
    overflow: scroll;
  }
  .btn {
    height: 10vh;
    width: 95%;
    margin: 0px auto;
  }
}
</style>